import useSWR from "swr";

import { SortQueryDirection, usePaginationControls } from "@ds-cps/ui";

import { SearchOrganizationsByEnum } from "@organization/models/Organization";
import { PagedOrganizationsResponse } from "@organization/models/PagedOrganizationsResponse";

import { organizationEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

import { CreateParamsForOrganizations } from "./CreateParamsForOrganizations";

export default function useGetOrganizations(
  sortField: string,
  sortDirection: SortQueryDirection,
  search?: string,
  searchBy?: SearchOrganizationsByEnum
) {
  const { pageIndex, pageSize } = usePaginationControls();

  const params = new CreateParamsForOrganizations();
  params.withPagination(pageSize, pageIndex);
  params.withSearch(search, searchBy);
  params.withSorting(sortField, sortDirection);

  const url = organizationEndpoints.search() + `?${params.toString()}`;

  const fetcherWithToken = (url: string) =>
    fetcher<PagedOrganizationsResponse>(url);

  const { data, error, isLoading, mutate } = useSWR(url, fetcherWithToken, {
    keepPreviousData: false, // to minimize "re-rendering effect" of table data and pagination data
    revalidateOnFocus: false
  });

  return {
    organizations: data?.organizations,
    totalCount: data?.total,
    isLoading,
    hasError: Boolean(error),
    mutate
  };
}
